import { useState, useEffect, RefObject } from 'react'

const useInViewport = (
  externalRef: RefObject<HTMLElement | null>,
  options?: IntersectionObserverInit,
): boolean => {
  const [isInViewport, setIsInViewport] = useState<boolean>(false)

  useEffect(() => {
    if (!('IntersectionObserver' in window) || !externalRef.current) return

    const targetElement = externalRef.current

    const observerCallback: IntersectionObserverCallback = (entries) => {
      const [entry] = entries
      setIsInViewport(entry.isIntersecting)
    }

    const observer = new IntersectionObserver(observerCallback, options)

    observer.observe(targetElement)

    return () => {
      observer.unobserve(targetElement)
    }
  }, [externalRef, options])

  return isInViewport
}

export default useInViewport
